import {
  Box,
  Button,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import PersonAddAlt1OutlinedIcon from "@mui/icons-material/PersonAddAlt1Outlined";
import AuthLayout, { authButtonClass } from "../../components/AuthLayout";
import { useState, useEffect, useRef } from "react";
import { signUpCustomer } from "../../api/customer";
import useErrorHandler from "../../hooks/useErrorHandler";
import useSnackbar from "../../hooks/useSnackbar";
import Captcha from "../../components/captcha";
// import "./Register.css";
//document.body.style = 'background: #e3e4e6; ';
export default function Register() {
  const snackbar = useSnackbar();
  const handleError = useErrorHandler();
  const initialValues = {
    email: "",
    company_name: "",
    password: "",
    phone: "",
    firstname: "",
    lastname: "",
    address: "",
    address2: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
  };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmit, setIsSubmit] = useState("");
  const captchaRef = useRef();
  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({ ...formValues, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormErrors(validate(formValues));
    const newdata = await captchaRef.current.checkAnswer();
    if (newdata[0] === true) {
      setIsSubmit(true);
    } else if (newdata[1] === "") {
      setErrorMsg("Enter the captcha.");
    } else {
      setErrorMsg("Captcha Mismatch");
    }
  };

  const signUp = async () => {
    setLoading(true);
    try {
      const { data } = await signUpCustomer(formValues);
      snackbar.showSuccess(data.msg);
      setLoading(false);
    } catch (err) {
      captchaRef.current?.numRefresh();
      setLoading(false);
      handleError(err);
      // snackbar.showError();
    }
  };

  useEffect(() => {
    if (Object.keys(formErrors).length === 0 && isSubmit) {
      signUp();
    }
  }, [formErrors]);
  const validate = (values) => {
    const errors = {};
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!values.firstname) {
      errors.firstname = "First name is required!";
    }
    if (!values.lastname) {
      errors.lastname = "Last name is required!";
    }
    if (!values.email) {
      errors.email = "Email is required!";
    } else if (!regex.test(values.email)) {
      errors.email = "This is not a valid email format!";
    }
    if (!values.company_name) {
      errors.company_name = "Company Name is required!";
    }
    // if (!values.password) {
    //   errors.password = "Password is required";
    // } else if (values.password.length < 4) {
    //   errors.password = "Password must be more than 4 characters";
    // } else if (values.password.length > 10) {
    //   errors.password = "Password cannot exceed more than 10 characters";
    // }
    if (!values.address) {
      errors.address = "Address is required";
    }
    if (!values.zipcode) {
      errors.zipcode = "Zip code is required";
    }

    if (!values.city) {
      errors.city = "City is required";
    }
    if (!values.state) {
      errors.state = "State is required";
    }
    if (!values.country) {
      errors.country = "Country is required";
    }

    if (!values.phone) {
      errors.phone = "Phone Number is required";
    } else if (values.phone.length < 10 || values.phone.length > 10) {
      errors.phone = "Please enter a valid 10-digit phone number";
    }
    return errors;
  };

  // label, name, type, grid width (out of 12)
  const sections = [
    {
      title: "Company",
      fields: [
        ["Company Name", "company_name", "text", 12],
        ["Email", "email", "text", 6],
        ["Phone", "phone", "number", 6],
      ],
    },
    {
      title: "Contact person",
      fields: [
        ["First Name", "firstname", "text", 6],
        ["Last Name", "lastname", "text", 6],
      ],
    },
    {
      title: "Address",
      fields: [
        ["Address", "address", "text", 12],
        ["Address 2", "address2", "text", 12],
        ["City", "city", "text", 6],
        ["State", "state", "text", 6],
        ["Country", "country", "text", 6],
        ["Zip code", "zipcode", "text", 6],
      ],
    },
  ];

  return (
    <AuthLayout
      title="Create your account"
      subtitle="Register your company to start resolving disputes online."
      icon={<PersonAddAlt1OutlinedIcon />}
      cardWidth={720}
      showFeatures={false}
    >
      <Box component="form" onSubmit={handleSubmit} noValidate>
        {sections.map((section) => (
          <Box key={section.title} mb={2.5}>
            <Typography variant="overline" color="text.secondary" display="block" mb={1}>
              {section.title}
            </Typography>
            <Grid container spacing={2}>
              {section.fields.map(([label, name, type, width]) => (
                <Grid item xs={12} sm={width} key={name}>
                  <TextField
                    size="small"
                    fullWidth
                    label={label}
                    type={type}
                    name={name}
                    value={formValues[name]}
                    onChange={handleChange}
                    error={Boolean(formErrors[name])}
                    helperText={formErrors[name]}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
        ))}

        <Box mb={2.5}>
          <Captcha errorMsg={errorMsg} ref={captchaRef} />
        </Box>

        <Button type="submit" variant="contained" fullWidth size="large" disabled={loading} className={authButtonClass}>
          {loading ? <CircularProgress size={24} className="!text-white" /> : "Create account"}
        </Button>
      </Box>
    </AuthLayout>
  );
}
